import React from 'react'
import Hero from '../../../components/site/Hero'
import Services from '../../../components/site/Services'
import Process from '../../../components/site/Process'
import Portal from '../../../components/site/Portal'
import OurWork from '../../../components/site/OurWork'
import Testimonials from '../../../components/site/Testimonials'
import Addresses from '../../../components/site/Addresses'
import FinalCta from '../../../components/site/FinalCta'
import Reveal from '../../../components/reveal'
import { sections, services, steps, features, testimonials, addresses, heroStats, heroWorkflow, ourWork } from '../../../content/site'

const Index = () => {
  return (
    <>
      <Hero section={sections.hero} heroStats={heroStats} heroWorkflow={heroWorkflow} />
      <Reveal><Services section={sections.services} services={services} /></Reveal>
      <Reveal><Process section={sections.process} steps={steps} /></Reveal>
      <Reveal><Portal section={sections.portal} features={features} /></Reveal>
      <Reveal><OurWork block={ourWork} /></Reveal>
      <Reveal><Testimonials section={sections.testimonials} testimonials={testimonials} /></Reveal>
      <Reveal><Addresses section={sections.addresses} addresses={addresses} /></Reveal>
      <Reveal><FinalCta section={sections.finalCta} /></Reveal>
    </>
  )
}

export default Index
